import React from "react";
import "./NavBar.css";
import logo from "../images/logo.png";
import {Link} from "react-router-dom";
 

function NavBar() {
    return(
        <div>
            <nav className="navbar navbar-expand-lg navbar-dark NavBarCustom">
                <div className="logo">
                    <div className="navbar-brand">
                        <img src={logo} width="40" height="40" alt="" />
                    </div>
                    <h3 className="navbar-brand">
                        <strong>ENIRISST</strong>
                    </h3>
                </div>
                <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarTogglerDemo02" aria-controls="navbarTogglerDemo02" aria-expanded="false" aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"></span>
                </button>
                <div className="collapse navbar-collapse customNavBar" id="navbarTogglerDemo02">
                <ul className="navbar-nav ml-auto">
                    <li className="nav-item">
                    <Link className="nav-link" to="/"> Αρχική </Link>
                    </li>
                    <li className="nav-item">

                    <Link className="nav-link" to="/RoadTransport"> Οι οδικές μεταφορές στη χώρα με αριθμούς </Link>
                    </li>
                    <li className="nav-item">
                    <Link className="nav-link" to="/Simulation"> Προσομοίωση μετακινήσεων </Link>
                    </li>
                    </ul>
                </div>
            </nav>
        </div>

    );
}


export default NavBar;